import { render } from "./RegressionPage.vue?vue&type=template&id=4a541008&scoped=true"
import script from "./RegressionPage.vue?vue&type=script&lang=js"
export * from "./RegressionPage.vue?vue&type=script&lang=js"

import "./RegressionPage.vue?vue&type=style&index=0&id=4a541008&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a541008"]])

export default __exports__